export interface IPatientExportability {

    id: number,
    patientAlias: string,
    patientCenterId: number,
    patientCenterAlias: string,
    patientType: string,
    chainNumber: Number,
    cluster: Number,
    position: Number,
    patientStatus: string
}


